module.exports = __webpack_public_path__ + "img/network-devices.0fcbab8c.svg";